import { PayWallFeature, PayWallOrgFeature } from '../Redux/Reducer.type';
import { FEATURES_TO_OVERWRITE_ORG } from '../Redux/Selectors';

export function processOrgFeatures(orgFeatures: PayWallOrgFeature[], availableFeatures: PayWallFeature[]) {
  return orgFeatures.map((feature) => {
    if (FEATURES_TO_OVERWRITE_ORG.includes(feature.name)) {
      return availableFeatures.find((availableFeature) => availableFeature.name === feature.name) ?? feature;
    }

    return feature;
  });
}
